import { Snackbar as MuiSnackbar } from '@mui/material';

export default MuiSnackbar;
